module.exports = __webpack_public_path__ + "static/media/mine.787c3cc7.jpg";